<template>
  <div>
    <canvas ref="bubbleChartCanvas"></canvas>
  </div>
</template>

<script>
export default {
  name: 'BubbleChart',
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.updateChart();
      },
    },
  },
  mounted() {
    this.createChart();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
  },
  methods: {
    createChart() {
      if (typeof Chart === 'undefined') {
        console.error('Chart.js non è disponibile');
        return;
      }
      const ctx = this.$refs.bubbleChartCanvas.getContext('2d');
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }
      this.chartInstance = new Chart(ctx, {
        type: 'bubble',
        data: this.chartData,
        options: this.chartOptions,
      });
    },
    updateChart() {
      if (!this.chartInstance) {
        this.createChart();
        return;
      }
      this.chartInstance.data = this.chartData;
      this.chartInstance.options = this.chartOptions;
      this.chartInstance.update();
    },
    resize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/BubbleChart.vue